import { useEffect } from "react";
import {
  Grid,
  SolarFinancingFeatures,
  SolarFinancingHero,
  SolarFinancingVideos,
  SolarFinancingTestimonials,
  SolarFinancingPartners,
  SolarFinancingContactUs,
  SolarFinancingFAQs,
} from "../components";
import { Navbar, Footer } from "../layouts";
import { Helmet } from "react-helmet-async";

const SolarFinancingPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Get Solar Financing of up to ₦100M | Checkoff Finance</title>

        <meta
          name="description"
          content="Get solar financing in Nigeria with Checkoff Finance. Up to ₦6 million for salary earners and ₦100 million for businesses. Pay just 30% upfront, spread the balance over 18 months. 260+ customers, 47+ vendor partners across 13+ states."
        />

        <meta
          name="keywords"
          content="solar financing Nigeria, solar loan Nigeria, solar power financing, buy solar on installments Nigeria, Checkoff Finance solar, solar energy loan, business solar financing, salary earner solar loan, solar payment plan Nigeria, alternative power financing Nigeria"
        />

        <meta
          property="og:title"
          content="Get Solar Financing of up to ₦100M | Checkoff Finance"
        />

        <meta
          property="og:description"
          content="With rising fuel prices and unreliable power, switch to solar. Pay 30% down, spread the rest over 24 months. ₦1.13B+ in solar projects financed across Nigeria."
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content="https://checkoff.finance/solar-financing"
        />

        <meta name="robots" content="index, follow" />

        <link rel="canonical" href="https://checkoff.finance/solar-financing" />
      </Helmet>
      <Navbar />
      <Grid />
      <SolarFinancingHero />
      <SolarFinancingFeatures />
      <SolarFinancingPartners />
      <SolarFinancingVideos />
      <SolarFinancingContactUs />
      <SolarFinancingTestimonials />
      <SolarFinancingFAQs displaySeeMore={true} />
      <Footer />
    </>
  );
};

export default SolarFinancingPage;
